import CmsContentPage from "./CmsContentPage";

const FALLBACK =
  "https://images.unsplash.com/photo-1696581081881-c3d57934f4be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxmZXJyYXJpJTIwcmVkJTIwc3BvcnRzJTIwY2FyfGVufDB8fHx8MTc3ODA1MzYwMnww&ixlib=rb-4.1.0&q=85";

const OverOnsPage = () => (
  <CmsContentPage
    pageKey="over-ons"
    fallbackHero={FALLBACK}
    dataTestId="over-ons-page"
  />
);

export default OverOnsPage;
